
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, option_type, class_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { compare, addDays, equals, now, date as date_1, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { toArray, map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { isEmpty, item, mapIndexed, concat, sortBy, length, singleton as singleton_1, ofArray, tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals as equals_1, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { iterate, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ImageViewer } from "./ImageViewer.js";
import { Avatar, participantColor } from "./Avatar.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import Delete_1 from "../../public/assets/icons/Delete_1.svg";
import { IconPaperPlane, IconPaperclip } from "./Icon.js";

export class ChatParticipant extends Record {
    constructor(Id, Name, Role) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Role = Role;
    }
}

export function ChatParticipant_$reflection() {
    return record_type("Components.GroupChat.ChatParticipant", [], ChatParticipant, () => [["Id", string_type], ["Name", string_type], ["Role", string_type]]);
}

export class ChatMessage extends Record {
    constructor(Id, AuthorId, Timestamp, Text$, ImageUrl) {
        super();
        this.Id = Id;
        this.AuthorId = AuthorId;
        this.Timestamp = Timestamp;
        this.Text = Text$;
        this.ImageUrl = ImageUrl;
    }
}

export function ChatMessage_$reflection() {
    return record_type("Components.GroupChat.ChatMessage", [], ChatMessage, () => [["Id", string_type], ["AuthorId", string_type], ["Timestamp", class_type("System.DateTime")], ["Text", string_type], ["ImageUrl", option_type(string_type)]]);
}

export class ChatStatusEvent extends Record {
    constructor(AuthorId, Timestamp, StatusLabel, DotColor) {
        super();
        this.AuthorId = AuthorId;
        this.Timestamp = Timestamp;
        this.StatusLabel = StatusLabel;
        this.DotColor = DotColor;
    }
}

export function ChatStatusEvent_$reflection() {
    return record_type("Components.GroupChat.ChatStatusEvent", [], ChatStatusEvent, () => [["AuthorId", string_type], ["Timestamp", class_type("System.DateTime")], ["StatusLabel", string_type], ["DotColor", string_type]]);
}

export class ChatEntry extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Message", "StatusEvent"];
    }
}

export function ChatEntry_$reflection() {
    return union_type("Components.GroupChat.ChatEntry", [], ChatEntry, () => [[["Item", ChatMessage_$reflection()]], [["Item", ChatStatusEvent_$reflection()]]]);
}

export function ChatEntry__get_Timestamp(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Timestamp;
    }
    else {
        return this$.fields[0].Timestamp;
    }
}

function timeOf(timestamp) {
    return toString(toLocalTime(timestamp), "HH:mm");
}

function dateOf(timestamp) {
    return toString(toLocalTime(timestamp), "dd.MM.yyyy");
}

function participantName(participants, authorId) {
    return defaultArg(map((participant_1) => participant_1.Name, tryFind((participant) => (participant.Id === authorId), participants)), "");
}

function participantRole(participants, authorId) {
    return defaultArg(map((participant_1) => participant_1.Role, tryFind((participant) => (participant.Id === authorId), participants)), "");
}

function DateDivider(props) {
    let elems;
    const i18n = useTranslation()[1];
    const today = date_1(now());
    const day = date_1(toLocalTime(props.Date));
    const date = dateOf(props.Date);
    let label;
    if (equals(day, today)) {
        const arg_1 = {
            date: date,
        };
        label = (i18n.t("chat.date_today", arg_1));
    }
    else if (equals(day, addDays(today, -1))) {
        const arg_3 = {
            date: date,
        };
        label = (i18n.t("chat.date_yesterday", arg_3));
    }
    else {
        label = date;
    }
    return reactElement("div", createObj(ofArray([["data-test-id", "chat-date-divider"], ["className", join(" ", ["flex", "items-center", "gap-3", "text-[#888888]", "text-[12px]", "font-semibold"])], (elems = [reactElement("div", {
        className: join(" ", ["flex-1", "h-px", "bg-[#EAEAEA]"]),
    }), label, reactElement("div", {
        className: join(" ", ["flex-1", "h-px", "bg-[#EAEAEA]"]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function MessageImage(props) {
    let elems;
    const patternInput = reactApi.useState(false);
    const setIsViewerOpen = patternInput[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("p-[6px]"), delay(() => (props.IsMine ? append(singleton("bg-primary"), delay(() => singleton("rounded-[10px_2px_10px_10px]"))) : append(singleton("bg-[#F2F4F3]"), delay(() => singleton("rounded-[2px_10px_10px_10px]")))))))))], (elems = [reactElement("img", {
        "data-test-id": "chat-message-image",
        className: join(" ", ["w-[220px]", "h-[150px]", "max-w-full", "object-cover", "rounded-[6px]", "border", "border-[#E6E6E6]", "bg-white", "cursor-pointer"]),
        src: props.ImageUrl,
        onClick: (_arg) => {
            setIsViewerOpen(true);
        },
    }), ImageViewer({
        Images: singleton_1({
            Src: props.ImageUrl,
        }),
        IsOpen: patternInput[0],
        OnClose: () => {
            setIsViewerOpen(false);
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function MessageBubble(props) {
    return reactElement("div", {
        "data-test-id": "chat-message-text",
        className: join(" ", toList(delay(() => append(singleton("px-[14px]"), delay(() => append(singleton("py-[10px]"), delay(() => append(singleton("text-[14px]"), delay(() => append(singleton("whitespace-pre-wrap"), delay(() => append(singleton("break-words"), delay(() => (props.IsMine ? append(singleton("bg-primary"), delay(() => append(singleton("text-white"), delay(() => singleton("rounded-[10px_2px_10px_10px]"))))) : append(singleton("bg-[#F2F4F3]"), delay(() => append(singleton("text-[#111111]"), delay(() => singleton("rounded-[2px_10px_10px_10px]"))))))))))))))))))),
        children: props.Text,
    });
}

function OwnMessage(props) {
    let elems_2;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["data-test-id", "chat-message-own"], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("items-end"), delay(() => append(singleton("gap-1"), delay(() => (props.IsGroupHead ? singleton("mt-[14px]") : empty()))))))))))))], (elems_2 = toList(delay(() => {
        let elems;
        return append(props.IsGroupHead ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-[12px]", "text-[#555555]", "flex", "gap-[6px]"])], (elems = [reactElement("span", {
            className: join(" ", ["font-bold", "text-[#111111]"]),
            children: patternInput[0]("chat.you"),
        }), reactElement("span", {
            children: timeOf(props.Message.Timestamp),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            let elems_1;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-end", "gap-1", "max-w-[62%]"])], (elems_1 = toList(delay(() => append(!isNullOrWhiteSpace(props.Message.Text) ? singleton(createElement(MessageBubble, {
                IsMine: true,
                Text: props.Message.Text,
            })) : empty(), delay(() => {
                const matchValue = props.Message.ImageUrl;
                if (matchValue == null) {
                    return empty();
                }
                else {
                    return singleton(createElement(MessageImage, {
                        ImageUrl: matchValue,
                        IsMine: true,
                    }));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function TheirMessage(props) {
    let elems_2;
    const color = participantColor(props.Message.AuthorId);
    return reactElement("div", createObj(ofArray([["data-test-id", "chat-message-other"], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("gap-[10px]"), delay(() => append(singleton("items-start"), delay(() => (props.IsGroupHead ? singleton("mt-[14px]") : empty()))))))))))], (elems_2 = toList(delay(() => append(props.IsGroupHead ? singleton(createElement(Avatar, {
        Id: props.Message.AuthorId,
        Name: props.Name,
        Size: 32,
    })) : singleton(reactElement("div", {
        className: join(" ", ["w-8", "shrink-0"]),
    })), delay(() => {
        let elems_1;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1", "max-w-[62%]", "min-w-0"])], (elems_1 = toList(delay(() => {
            let elems;
            return append(props.IsGroupHead ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-[12px]", "text-[#555555]", "flex", "gap-[6px]", "items-baseline", "flex-wrap"])], (elems = toList(delay(() => append(singleton(reactElement("span", {
                className: join(" ", ["font-bold"]),
                style: {
                    color: color.Ink,
                },
                children: props.Name,
            })), delay(() => append((props.Role !== "") ? append(singleton(reactElement("span", {
                children: props.Role,
            })), delay(() => singleton(reactElement("span", {
                children: "·",
            })))) : empty(), delay(() => singleton(reactElement("span", {
                children: timeOf(props.Message.Timestamp),
            })))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => append(!isNullOrWhiteSpace(props.Message.Text) ? singleton(createElement(MessageBubble, {
                IsMine: false,
                Text: props.Message.Text,
            })) : empty(), delay(() => {
                const matchValue = props.Message.ImageUrl;
                if (matchValue == null) {
                    return empty();
                }
                else {
                    return singleton(createElement(MessageImage, {
                        ImageUrl: matchValue,
                        IsMine: false,
                    }));
                }
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StatusEventPill(props) {
    let elems, arg_1;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["data-test-id", "chat-status-event"], ["className", join(" ", ["self-center", "mt-[14px]", "text-[12px]", "text-[#666666]", "flex", "items-center", "gap-2", "px-[10px]", "py-1", "border", "border-[#EAEAEA]", "rounded-full"])], (elems = [reactElement("span", {
        className: join(" ", ["w-[6px]", "h-[6px]", "rounded-full", "shrink-0"]),
        style: {
            backgroundColor: props.Event.DotColor,
        },
    }), (arg_1 = {
        name: props.Name,
        status: props.Event.StatusLabel,
        time: timeOf(props.Event.Timestamp),
    }, patternInput[1].t("chat.status_changed", arg_1))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function isGroupHead(previous, message) {
    let matchResult, previousMessage;
    if (previous == null) {
        matchResult = 1;
    }
    else if (previous.tag === 1) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        previousMessage = previous.fields[0];
    }
    switch (matchResult) {
        case 0:
            if (previousMessage.AuthorId !== message.AuthorId) {
                return true;
            }
            else {
                return timeOf(previousMessage.Timestamp) !== timeOf(message.Timestamp);
            }
        default:
            return true;
    }
}

export function ChatFeed(props) {
    let elems;
    const feedRef = reactApi.useRef(undefined);
    const scrollToBottom = () => {
        iterate((element) => {
            element.scrollTop = element.scrollHeight;
        }, toArray(feedRef.current));
    };
    const dependencies = [length(props.Entries)];
    reactApi.useEffect(() => {
        scrollToBottom();
        window.setTimeout((_arg_1) => {
            scrollToBottom();
        }, 50);
    }, dependencies);
    const entries = sortBy(ChatEntry__get_Timestamp, props.Entries, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const elements = concat(mapIndexed((index, entry_1) => {
        const previous = (index === 0) ? undefined : item(index - 1, entries);
        const showDateDivider = (previous == null) ? true : (dateOf(ChatEntry__get_Timestamp(previous)) !== dateOf(ChatEntry__get_Timestamp(entry_1)));
        return toList(delay(() => append(showDateDivider ? singleton(createElement(DateDivider, {
            Date: ChatEntry__get_Timestamp(entry_1),
        })) : empty(), delay(() => {
            const matchValue = entry_1;
            return (matchValue.tag === 1) ? singleton(createElement(StatusEventPill, {
                Event: matchValue.fields[0],
                Name: participantName(props.Participants, matchValue.fields[0].AuthorId),
            })) : ((matchValue.fields[0].AuthorId === props.CurrentUserId) ? singleton(createElement(OwnMessage, {
                IsGroupHead: showDateDivider ? true : isGroupHead(previous, matchValue.fields[0]),
                Message: matchValue.fields[0],
            })) : singleton(createElement(TheirMessage, {
                IsGroupHead: showDateDivider ? true : isGroupHead(previous, matchValue.fields[0]),
                Message: matchValue.fields[0],
                Name: participantName(props.Participants, matchValue.fields[0].AuthorId),
                Role: participantRole(props.Participants, matchValue.fields[0].AuthorId),
            })));
        }))));
    }, entries));
    return reactElement("div", createObj(ofArray([["data-test-id", "chat-feed"], ["ref", (element_1) => {
        if (!Operators_IsNull(element_1)) {
            feedRef.current = element_1;
        }
    }], ["className", join(" ", ["flex-1", "min-h-0", "overflow-auto", "p-[22px]", "flex", "flex-col", "gap-[6px]"])], (elems = toList(delay(() => (isEmpty(elements) ? singleton(reactElement("div", {
        className: join(" ", ["text-center", "text-[#888888]", "text-[14px]"]),
        children: props.EmptyText,
    })) : elements))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ChatInput(props) {
    let elems_5;
    const patternInput = reactApi.useState("");
    const setMessage = patternInput[1];
    const message = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setImage = patternInput_1[1];
    const image = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setPreviewUrl = patternInput_2[1];
    const previewUrl = patternInput_2[0];
    const fileInputRef = reactApi.useRef(undefined);
    const isSubmitting = props.FormState.IsLoading;
    const removeImage = () => {
        iterate((arg) => {
            URL.revokeObjectURL(arg);
        }, toArray(previewUrl));
        setImage(undefined);
        setPreviewUrl(undefined);
    };
    const canSubmit = !isSubmitting && (!isNullOrWhiteSpace(message) ? true : (image != null));
    const submit = () => {
        if (canSubmit) {
            props.OnSubmit(message.trim(), image);
            setMessage("");
            removeImage();
        }
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-[10px]", "px-[22px]", "pt-[14px]", "pb-[18px]", "border-t", "border-[#EAEAEA]", "print:hidden"])], (elems_5 = toList(delay(() => {
        let matchValue, url, elems_1, elems;
        return append((matchValue = previewUrl, (matchValue == null) ? (empty()) : ((url = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["relative", "w-24"])], (elems_1 = [reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", "chat-remove-image-button"], ["className", join(" ", ["absolute", "top-1", "right-1", "h-5", "w-5", "p-1", "rounded-full", "text-red", "bg-white", "cursor-pointer"])], ["disabled", isSubmitting], ["onClick", (_arg) => {
            if (!isSubmitting) {
                removeImage();
            }
        }], (elems = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("img", {
            className: join(" ", ["rounded-[6px]", "border", "border-[#E6E6E6]", "w-24", "h-20", "object-cover"]),
            src: url,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))), delay(() => {
            let elems_4;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-[10px]"])], (elems_4 = toList(delay(() => append(props.CanAttachImage ? append(singleton(reactElement("input", {
                ref: (element) => {
                    if (!Operators_IsNull(element)) {
                        fileInputRef.current = element;
                    }
                },
                type: "file",
                accept: ".jpg, .jpeg, .png",
                className: join(" ", ["hidden"]),
                onChange: (ev) => {
                    const files = ev.target.files;
                    if (!(files == null) && (files.length > 0)) {
                        const file = files.item(0);
                        iterate((arg_1) => {
                            URL.revokeObjectURL(arg_1);
                        }, toArray(previewUrl));
                        setImage(file);
                        setPreviewUrl(URL.createObjectURL(file));
                    }
                },
            })), delay(() => {
                let elems_2;
                return singleton(reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", "chat-upload-image-button"], ["title", props.AttachTitle], ["disabled", isSubmitting], ["className", join(" ", ["w-11", "h-11", "shrink-0", "flex", "items-center", "justify-center", "border", "border-[#D6D6D6]", "bg-white", "rounded-lg", "text-[#555555]", "cursor-pointer", "hover:bg-[#F4F4F4]", "disabled:opacity-50"])], ["onClick", (_arg_1) => {
                    const matchValue_1 = fileInputRef.current;
                    if (matchValue_1 == null) {
                    }
                    else {
                        const element_1 = matchValue_1;
                        element_1.click();
                    }
                }], (elems_2 = [IconPaperclip(18)], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            })) : empty(), delay(() => {
                let value_34;
                return append(singleton(reactElement("input", createObj(ofArray([["data-test-id", "chat-message-input"], ["type", "text"], (value_34 = message, ["ref", (e) => {
                    if (!Operators_IsNull(e) && !equals_1(e.value, value_34)) {
                        e.value = value_34;
                    }
                }]), ["placeholder", props.Placeholder], ["disabled", isSubmitting], ["onChange", (ev_1) => {
                    setMessage(ev_1.target.value);
                }], ["onKeyDown", (event) => {
                    if ((event.key === "Enter") && !event.shiftKey) {
                        event.preventDefault();
                        submit();
                    }
                }], ["className", join(" ", ["flex-1", "min-w-0", "h-11", "border", "border-[#D6D6D6]", "rounded-lg", "px-[14px]", "text-[14px]", "outline-none", "focus:border-primary"])]])))), delay(() => {
                    let elems_3;
                    return singleton(reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", "chat-submit-button"], ["disabled", !canSubmit], ["onClick", (_arg_2) => {
                        submit();
                    }], ["className", join(" ", ["h-11", "shrink-0", "flex", "items-center", "gap-2", "px-4", "bg-primary", "text-white", "rounded-lg", "text-[14px]", "font-semibold", "cursor-pointer", "disabled:opacity-50", "disabled:cursor-not-allowed"])], (elems_3 = [props.SendLabel, IconPaperPlane(16)], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

